import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	portletInfoContainer: {
		flex: 1
	},
	portletLimitedSize: {
		maxWidth: 300,
		paddingRight: theme.spacing(2)
	},
	children: {
		flex: 1
	},
	copyWebhookUrlContainer: {
		maxWidth: 400
	},
	copyWebhookUrlText: {
		paddingRight: theme.spacing(2),
		wordBreak: "break-all"
	},
	copyWebhookUrlChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100]),
		fontSize: 14,
		height: 20
	},
	testWebhookUrlChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
		fontSize: 14,
		height: 20
	}
}))

export default useStyles
